import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import './Dropdown.scss';

const SIZES = ['small', 'default'];

class Dropdown extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    block: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    size: PropTypes.oneOf(SIZES),
    error: PropTypes.string,
    errorMessage: PropTypes.string,
    /** If set, the icon is shown at left */
    iconName: PropTypes.string,
  };

  static defaultProps = {
    block: true,
    className: '',
    disabled: false,
    size: 'default',
    onChange: () => {},
  };

  render() {
    const {
      value,
      id,
      name,
      className,
      block,
      disabled,
      children,
      error,
      size,
      iconName,
      onChange,
    } = this.props;

    const content = (
      <select
        id={id}
        name={name ? name : id}
        className={classnames('common-dropdown__inner', className, {
          'common-dropdown--block': block,
          'common-dropdown--disabled': disabled,
        })}
        value={value}
        onChange={e => onChange(e.target.value)}
      >
        {children}
      </select>
    );

    const leftIcon = iconName && (
      <div className="common-dropdown__left-icon">
        <i className={classnames('fa', `fa-${iconName}`)} />
      </div>
    );

    const dropIcon = (
      <i
        className={classnames('common-dropdown__drop-icon fa fa-caret-down', {
          'common-dropdown__drop-icon--disabled': disabled,
        })}
      />
    );

    const errorMessage = error && (
      <div className="common-dropdown__error">{error}</div>
    );

    return (
      <div
        className={classnames(
          'common-dropdown',
          `common-dropdown--size-${size}`,
          {
            'common-dropdown--block': block,
            'common-dropdown--error': error,
          }
        )}
      >
        <div className="common-dropdown__row">
          {leftIcon}
          {content}
          {dropIcon}
        </div>
        {errorMessage}
      </div>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/common/dropdown/Dropdown.js